import { Card, Divider } from "antd";
import { Discount, SubeventSelectionResponse } from "../../data/PrebookingResponse";
import { useSubevents } from "../../data/Subevents";
import { usePasses } from "../../data/Passes";
import { PassSelected } from "../../data/PrebookingRequest";
import dayjs from "dayjs";
import "dayjs/locale/de"
import { Fragment } from "react";
dayjs.locale('de')

interface PricesCardProps {
    name: string;
    fullPriceWithoutQueueBeforeDiscount: number;
    fullPriceWithoutQueueAfterDiscount: number;
    fullPriceWithQueueBeforeDiscount: number;
    fullPriceWithQueueAfterDiscount: number;
    discounts: Discount[];
    subevents: SubeventSelectionResponse[];
    loading: boolean;
    pass: PassSelected | null;
}

function PricesCard(props: PricesCardProps) {
    const subevents = useSubevents(state => state.subevents);
    const passes = usePasses(state => state.passes);

    return (
        <Card size="small" title={props.name} loading={props.loading}
            style={{
                textAlign: "left",
                boxShadow: "0px 0px 20px 10px rgba(0,0,0,.1)",
                border: "none"
            }}
            headStyle={{ textAlign: "center" }}>
            {props.pass !== null ? <p style={{ margin: 0 }}><b>Pass</b>: {passes.find(x => x.passId === props.pass?.passId)?.name}</p> : null}
            <h4 style={{ marginTop: "0px", marginBottom: "0px", color: "black" }}>{props.pass !== null ? "Contains:" : "Selection:"}</h4>
            <ul style={{ marginTop: "0px", color: "black" }}>
                {
                    props.subevents.slice(0).sort(
                        (a, b) => {
                            return dayjs(subevents.find(s => s.id === a.subeventId)?.date).unix() - dayjs(subevents.find(s => s.id === b.subeventId)?.date).unix()
                        }
                    ).map(x =>
                        <li style={{ opacity: x.inQueue ? "0.6" : "1" }}>
                            <p style={{ margin: 0 }}><b>{subevents.find(s => s.id === x.subeventId)?.name}</b><i> as {x.role === 0 ? "Leader" : (x.role === 1 ? "Follower" : "Couple")}</i>: {x.price}</p>
                            <p style={{ margin: 0 }}>{x.inQueue ? " (in queue at position " + x.inQueue + ")" : null}</p>
                        </li>
                    )
                }
            </ul>
            <div style={{ textAlign: "right", color: "black" }}>
                <Divider type="horizontal" style={{ borderTop: "1px black dashed", marginTop: "0px", marginBottom: "10px" }} />
                {props.discounts.length > 0 &&
                    <Fragment>
                        <p style={{ margin: 0 }}>{props.fullPriceWithQueueBeforeDiscount}</p>
                        {props.discounts.map(x => <p style={{ margin: 0 }}><i>({x.discountName}) -{x.discountValue}</i></p>)}
                    </Fragment>
                }
                <p style={{ margin: 0 }}><b>Total</b>: {props.fullPriceWithQueueAfterDiscount}</p>
                <p style={{ opacity: 0.6, margin: 0 }}>
                    {props.subevents.filter(x => x.inQueue).length > 0 ? ("Price without Passes in queue: " + props.fullPriceWithoutQueueAfterDiscount) : null}</p>
            </div>
        </Card>
    );
}

export default PricesCard;